// API 统一导出文件 - 替换 Firebase 配置
// 这个文件用来替换原来的 src/firebase/config.js

// 导入所有 API 服务
import { apiClient, API_ENDPOINTS, API_BASE_URL } from './config.js';
import authService, { 
  auth, 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut 
} from './auth.js';
import noticeService, {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp
} from './notices.js';

// 模拟 Firebase 的 db 对象
export const db = {
  _type: 'database'
};

// 模拟 Firebase 的 storage 对象
export const storage = {
  _type: 'storage'
};

// 导出认证相关
export { 
  auth, 
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut 
};

// 导出 Firestore 相关
export {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp
};

// 添加缺失的 Firestore 函数
export const getDoc = async (docRef) => {
  // 模拟 Firebase getDoc 函数
  try {
    const response = await apiClient.get(`${API_ENDPOINTS.SETTINGS.ACCESS}/${docRef.id}`);
    return {
      exists: () => !!response,
      data: () => response || {}
    };
  } catch (error) {
    return {
      exists: () => false,
      data: () => ({})
    };
  }
};

export const setDoc = async (docRef, data, options = {}) => {
  // 模拟 Firebase setDoc 函数
  try {
    if (options.merge) {
      await apiClient.put(`${API_ENDPOINTS.SETTINGS.ACCESS}/${docRef.id}`, data);
    } else {
      await apiClient.post(`${API_ENDPOINTS.SETTINGS.ACCESS}/${docRef.id}`, data);
    }
    return Promise.resolve();
  } catch (error) {
    console.error('setDoc error:', error);
    throw error;
  }
};

// 模拟 Firebase Timestamp
export const Timestamp = {
  now: () => new Date(),
  fromDate: (date) => date,
  toDate: function() { return this; }
};

// 模拟认证相关函数
// eslint-disable-next-line no-unused-vars
export const updatePassword = async (user, newPassword) => {
  // 调用真正的修改密码 API
  try {
    const response = await authService.changePassword(newPassword);
    return response;
  } catch (error) {
    console.error('updatePassword error:', error);
    throw error;
  }
};

export const sendEmailVerification = async (user) => {
  // 在实际应用中，这里应该调用发送验证邮件的 API
  console.log('sendEmailVerification called for user:', user?.email);
  // 暂时返回成功，实际应用中需要实现
  return Promise.resolve();
};

// 导出服务实例
export { authService, noticeService };

// 导出 API 配置
export { apiClient, API_ENDPOINTS, API_BASE_URL };

// 模拟 Firebase Storage 的函数
export const ref = (storage, path) => {
  return { _path: path };
};

export const uploadBytesResumable = (storageRef, file) => {
  // 返回一个模拟的上传任务
  return {
    on: (event, progressCallback, errorCallback, completeCallback) => {
      // 模拟上传过程
      setTimeout(async () => {
        try {
          // 调用实际的上传 API
          const url = await noticeService.uploadImage(file);
          
          // 模拟进度回调
          if (progressCallback) {
            progressCallback({ bytesTransferred: file.size, totalBytes: file.size });
          }
          
          // 模拟完成回调
          if (completeCallback) {
            completeCallback();
          }
          
          // 存储下载 URL 以供 getDownloadURL 使用
          storageRef._downloadURL = url;
        } catch (error) {
          if (errorCallback) {
            errorCallback(error);
          }
        }
      }, 100);
    },
    snapshot: {
      ref: storageRef
    }
  };
};

export const getDownloadURL = async (storageRef) => {
  // 返回之前存储的下载 URL
  if (storageRef._downloadURL) {
    return storageRef._downloadURL;
  }
  throw new Error('No download URL available');
};

export const deleteObject = async (storageRef) => {
  // 在实际应用中，这里可能需要调用删除文件的 API
  console.log('Delete object:', storageRef._path);
  return Promise.resolve();
};

// 用户角色检查工具（替换 authUtils.js）
export const getUserRole = async (user) => {
  if (!user) {
    return 'user';
  }
  
  // 从认证服务中获取角色
  return authService.getUserRole();
};

// 默认导出主要服务
export default {
  auth,
  db,
  storage,
  authService,
  noticeService,
  apiClient
}; 